/**
 * 认证相关常量
 * 集中管理登录/验证码相关的魔数，禁止在业务代码中硬编码
 */

// 登录方式 Tab ID
export const LOGIN_TAB = {
  ACCOUNT: 1000, // 账号密码登录
  PHONE: 1001, // 手机号登录
};

// 短信验证码用途
export const SMS_USE_TYPE = {
  LOGIN: 0, // 登录
  REGISTER: 1, // 注册
  RESET_PASSWORD: 2, // 重置密码
};

// 短信模板类型
export const SMS_MESSAGE_TYPE = {
  LOGIN: 4001, // 登录验证码
};

// 验证码倒计时秒数
export const SMS_COUNTDOWN_SECONDS = 60;

// 防水墙 AppID（与 account.vue 共用）
export const CAPTCHA_APP_ID = '2035581235';

// 接口路径（集中管理，后端接口变更时只改此处）
export const API_PATH = {
  SEND_CODE: '/general-login_api/send-verify-code', // 发送验证码
  LOGIN: '/general-login_api/login', // 登录（复用现有）
  BS_INFO: '/general-login_api/bs/info', // 业务系统信息
};
